import { WaitingRoomWebSocketState } from '../types/waitingRoomWebsocket'

export const initialState: WaitingRoomWebSocketState = {
  isConnected: false,
  error: null,
  waitingRoomStatus: 1,
  gameEnded: false,
  charterTeamReadiness: {},
  charterAllTeamsReady: false,
}
